export default {
      id: "arrow_drop_down-usage",
      viewBox: "0 0 12 7",
      url: __webpack_public_path__ + "img/icons.187741c9.svg#arrow_drop_down",
      toString: function () {
        return this.url;
      }
    }